import { Module, MutationTree, ActionTree, GetterTree, Mutation } from 'vuex';
import { modelRequiredCommon } from '@/models/outbounds/requiredQuick';
import { MODEL_PAYMENT } from '@/lib/outbound/usePayment';
export class RegistryState {
  public registrySender: outbound.registry.pin = {
    name: '',
    phoneNumber: '',
    jibunAddress: '',
    detailAddress: '',
    dongName: '',
    postalCode: '',
    latitude: 0,
    longitude: 0,
    phoneValidate: false,
  };
  public registryReceiver: outbound.registry.pin = {
    name: '',
    phoneNumber: '',
    jibunAddress: '',
    detailAddress: '',
    dongName: '',
    latitude: 0,
    longitude: 0,
    postalCode: '',
    phoneValidate: false,
  };
  public registryReceivers: outbound.registry.pin[] = [];
  public policy: boolean = false;
  public registryType: outbound.registry.type = 'registeredMail';

  public customFields: outbound.customFields[] = [];
  public canUsePayment: boolean = false; //결제모달 오픈가능 여부
  public registryClientComment: string = '';
  public validatePopup: boolean = false;
  public receptionTimePopup: boolean = false;
  public mailCharge: outbound.registry.chargeType = {
    charge: '-',
    chargeUuid: '',
  };
  // 결제정보
  public payment: outbound.payment = MODEL_PAYMENT();

  //유효성 검증 여부만 boolean으로 확인
  public validationInfo: required.common = new modelRequiredCommon();

  /** 물품전달방법, 구내픽업 예약시간, 구내픽업 요청시간 */
  public customerDropOffMethod: outbound.itemDeliveryMethod = '';
  public onsitePickupRequestedAt: string = '';
  public onsitePickupClientComment: string = '';

  public nowIspickupReserveOvertime?: boolean = false;
  public nowIspickupServiceOvertime?: boolean = false;
}

const Mutations: MutationTree<RegistryState> = {
  updateRegistrySender(state: RegistryState, payload: outbound.registry.pin) {
    state.registrySender = payload;
  },
  updateRegistryReceiver(state: RegistryState, payload: outbound.registry.pin) {
    state.registryReceiver = payload;
  },
  updateRegistryReceivers(state: RegistryState, payload: outbound.registry.pin[]) {
    state.registryReceivers = payload;
  },
  updateRegistryPolicy(state: RegistryState, payload: boolean) {
    state.policy = payload;
  },

  updateRegistryType(state: RegistryState, payload: outbound.registry.type) {
    state.registryType = payload;
  },

  updateRegistryClientComment(state: RegistryState, payload: string) {
    state.registryClientComment = payload;
  },
  updateValidatePopup(state: RegistryState, payload: boolean) {
    state.validatePopup = payload;
  },
  updateReceptionTimePopup(state: RegistryState, payload: boolean) {
    state.receptionTimePopup = payload;
  },
  updateRegistryReceiverPhoneNumber(state: RegistryState, payload: string) {
    state.registryReceiver.phoneNumber = payload;
  },
  updateRegistrySenderPhoneNumber(state: RegistryState, payload: string) {
    state.registrySender.phoneNumber = payload;
  },
  updateRegistryCharge(state: RegistryState, payload: outbound.registry.chargeType) {
    state.mailCharge = payload;
  },
  updateValidateInfo(state: RegistryState, payload: required.common) {
    state.validationInfo = payload;
  },

  resetValidateInfo(state: RegistryState, payload: required.common) {
    state.validationInfo = payload;
  },
  updateCustomFields(state: RegistryState, payload: outbound.customFields[]) {
    state.customFields = payload;
  },
  //결제모달오픈 여부 업데이트
  updateCanUsePayment(state: RegistryState, payload: boolean) {
    state.canUsePayment = payload;
  },
  // payment(결제정보) 변경
  updatePayment(state: RegistryState, payload: vuex.outbound.updateData<outbound.payment>) {
    state.payment[payload.key] = payload.value;
  },
  updateCustomerDropOffMethod(state: RegistryState, payload: outbound.itemDeliveryMethod) {
    state.customerDropOffMethod = payload;
  },
  updateOnsitePickupRequestedAt(state: RegistryState, payload: string) {
    state.onsitePickupRequestedAt = payload;
  },
  updateOnsitePickupClientComment(state: RegistryState, payload: string) {
    state.onsitePickupClientComment = payload;
  },
  updateNowIspickupReserveOvertime(state: RegistryState, payload: boolean) {
    state.nowIspickupReserveOvertime = payload;
  },
  updateNowIspickupServiceOvertime(state: RegistryState, payload: boolean) {
    state.nowIspickupServiceOvertime = payload;
  },
};

const Actions: ActionTree<RegistryState, any> = {
  updateRegistrySender({ commit }, payload: outbound.registry.pin) {
    commit('updateRegistrySender', payload);
  },
  updateRegistryReceiver({ commit }, payload: outbound.registry.pin) {
    commit('updateRegistryReceiver', payload);
  },
  updateRegistryReceivers({ commit }, payload: outbound.registry.pin[]) {
    commit('updateRegistryReceivers', payload);
  },
  updateRegistryType({ commit }, payload: string) {
    commit('updateRegistryType', payload);
  },
  updateRegistryPolicy({ commit }, payload: boolean) {
    commit('updateRegistryPolicy', payload);
  },

  updateRegistryClientComment({ commit }, payload: string) {
    commit('updateRegistryClientComment', payload);
  },
  actionValidatePopup({ commit }, payload: boolean) {
    commit('updateValidatePopup', payload);
  },
  actionReceptionTimePopup({ commit }, payload: boolean) {
    commit('updateReceptionTimePopup', payload);
  },
  updateRegistryReceiverPhoneNumber({ commit }, payload: string) {
    commit('updateRegistryReceiverPhoneNumber', payload);
  },

  updateRegistryCharge({ commit }, payload: outbound.registry.chargeType) {
    commit('updateRegistryCharge', payload);
  },
  updateValidateInfo({ commit }, payload: required.common) {
    commit('updateValidateInfo', payload);
  },

  resetValidateInfo({ commit }) {
    commit('resetValidateInfo', new modelRequiredCommon());
  },
  updateCustomFields({ commit }, payload: outbound.customFields[]) {
    commit('updateCustomFields', payload);
  },

  updateCanUsePayment({ commit }, payload: boolean) {
    commit('updateCanUsePayment', payload);
  },
  updateCustomerDropOffMethod({ commit }, payload: outbound.itemDeliveryMethod) {
    commit('updateCustomerDropOffMethod', payload);
  },
  updateOnsitePickupRequestedAt({ commit }, payload: string) {
    commit('updateOnsitePickupRequestedAt', payload);
  },
  updateOnsitePickupClientComment({ commit }, payload: string) {
    commit('updateOnsitePickupClientComment', payload);
  },
  updateNowIspickupReserveOvertime({ commit }, payload: boolean) {
    commit('updateNowIspickupReserveOvertime', payload);
  },
  updateNowIspickupServiceOvertime({ commit }, payload: boolean) {
    commit('updateNowIspickupServiceOvertime', payload);
  },
  /**
   *  payment(결제수단) 변경
   */
  updatePayment({ commit }, payload: vuex.outbound.updateData<outbound.payment>) {
    commit('updatePayment', payload);
  },
};
const Getters: GetterTree<RegistryState, any> = {
  getValidateInfo: (state: RegistryState) => (): required.common => {
    return state.validationInfo;
  },
  getReceptionTimePopup: (state: RegistryState) => (): boolean => {
    return state.receptionTimePopup;
  },
  getCustomFields: (state: RegistryState) => (): outbound.customFields[] => {
    return state.customFields;
  },
  getPolicy: (state: RegistryState) => (): boolean => {
    return state.policy;
  },
  getRegistryType: (state: RegistryState) => (): outbound.registry.type => {
    return state.registryType;
  },
  getRegistryReceiverPhone: (state: RegistryState) => (): string => {
    return state.registryReceiver.phoneNumber;
  },
  getRegistryReceivers: (state: RegistryState) => (): outbound.registry.pin[] => {
    return state.registryReceivers;
  },
  getNowIspickupReserveOvertime: (state: RegistryState) => (): boolean => {
    return state.nowIspickupReserveOvertime || false;
  },
  getNowIspickupServiceOvertime: (state: RegistryState) => (): boolean => {
    return state.nowIspickupServiceOvertime || false;
  },
  getCustomerDropOffMethod: (state: RegistryState) => (): outbound.itemDeliveryMethod => {
    return state.customerDropOffMethod;
  },
  getRegistryData: (state: RegistryState) => (): outbound.registry.registryData => {
    // centerInfo는 registrySender의 주소 정보를 사용해서 재구성
    const centerInfo: api.client.getInfo.center = {
      centerId: '',
      jibunAddress: state.registrySender.jibunAddress || '',
      roadAddress: '',
      dongName: state.registrySender.dongName || '',
      detailAddress: state.registrySender.detailAddress || '',
      latitude: state.registrySender.latitude || 0,
      longitude: state.registrySender.longitude || 0,
      postalCode: state.registrySender.postalCode || '',
      detailAddressEng: '',
      jibunAddressEng: '',
      roadAddressEng: '',
    };

    return {
      senderInfo: {
        name: state.registrySender.name,
        phoneNumber: state.registrySender.phoneNumber,
        validate: state.registrySender.phoneValidate,
      },
      centerInfo,
      receiverInfo: state.registryReceiver,
      policy: state.policy,
      clientComment: state.registryClientComment,
      customFields: state.customFields,
      customerDropOffMethod: state.customerDropOffMethod,
      onsitePickupRequestedAt: state.onsitePickupRequestedAt,
      onsitePickupClientComment: state.onsitePickupClientComment,
    };
  },
};

const module: Module<RegistryState, any> = {
  namespaced: true,
  state: new RegistryState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
